import { ShareUsersState } from './ShareUsersState';
import { ShareUsersAction, ShareUsersActionType } from './actions';
import { Reducer } from 'redux';

export const shareUsersReducer: Reducer<ShareUsersState, ShareUsersAction> = (
    state = [],
    action
) => {
    switch (action.type) {
        case ShareUsersActionType.SET_SHARE_USERS: {
            return action.payload!;
        }
    }
    return state;
};
